import {Component} from "@angular/core";
import {TabsPageContainer} from "../../uiComponents/tabsPageContainer";

@Component({
	selector: 'threat-simulation-cfg-tabs',
	templateUrl: './threat-simulation-cfg-tabs.component.html',
})
export class ThreatSimulationsConfigTabsComponent extends TabsPageContainer {
}
